import type { ImportFileClearHandler } from "./import-file-clear-handler";

export class ImportFileClearListener {
    private handler: ImportFileClearHandler;

    public constructor(handler: ImportFileClearHandler) {
        this.handler = handler;
    }

    public register(input: HTMLInputElement, button: HTMLButtonElement): void {
        input.addEventListener("change", () => {
            this.handler.applyVisibility(input, button);
        });

        button.addEventListener("click", () => {
            this.handler.clear(input, button);
        });
    }
}
